define([
    'text!WebCommon/component/image-360.html',
    'jquery',

    'image360',
    'css!WebCommon/component/image-360.css'
], function(
    tpl,
    $
){
    return {
        template: tpl,
        props: {
            images: {
                type: Array
            },
            bgColor: {
                type: String
            }
        },
        computed: {
            image: function(){
                if (!this.images) return '';
                return this.images[0] || '';
            }
        },
        watch: {
            images: 'initImage360'
        },
        methods: {
            initImage360: function(){
                $(this.$el).image360({
                    img: {
                        num: this.images.length,
                        imgpath: '',
                        imgsuffix: 'jpg',
                        imginitnum: 0
                    },
                    autoplay: false,
                    auto: {
                        imgtime: 300,
                        imgdelay: 3000
                    }
                });
            }
        },
        mounted: function(){
            this.initImage360();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ../common/component/image-360.js
// module id = 283
// module chunks = 0